"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Search_1 = __importDefault(require("../../Input/Search"));

var index_1 = __importDefault(require("./index"));

var SearchFilterItem =
/** @class */
function (_super) {
  __extends(SearchFilterItem, _super);

  function SearchFilterItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.validOperators = ['in', 'like'];

    _this.onValueSelected = function (value) {
      _this.setState({
        selectedValues: value
      });

      _this.props.onChange(_this.props.id, value, _this.props.operator ? _this.props.operator : SearchFilterItem.defaultOperator);
    };

    _this.renderSearchBar = function () {
      var selectedValues = _this.state.selectedValues;
      var label = _this.props.label || _this.props.id;
      var value = '';

      if (Array.isArray(selectedValues)) {
        value = selectedValues[0] ? selectedValues[0].toString() : '';
      } else if (selectedValues) {
        value = selectedValues.toString();
      }

      return react_1.default.createElement("div", {
        className: "input_container"
      }, react_1.default.createElement("label", null, label), react_1.default.createElement(Search_1.default, {
        value: value,
        onSelected: _this.onValueSelected
      }));
    };

    _this.renderDropdownBody = function () {
      return _this.renderSearchBar();
    };

    _this.renderLabel = function () {
      return _this.renderSearchBar();
    };

    return _this;
  }

  SearchFilterItem.defaultOperator = 'like';
  return SearchFilterItem;
}(index_1.default);

exports.default = SearchFilterItem;